import { faker } from '@faker-js/faker';
import { CampaignStatus, CampaignTypes } from '@shared/constants';

export class MockCampaign {
  campaign_id: number;
  start_date: string;
  end_date: string;
  type_campaign: CampaignTypes;
  label: string = faker.date.month();
  max_gain_per_customer?: number = 50;
  status: CampaignStatus = CampaignStatus.RUNNING;
  targeting_end_date?: string = faker.date.past().toISOString();
  targeting_start_date?: string = faker.date.past().toISOString();
  deploy_on_customer_page?: string = faker.date.past().toISOString();

  constructor(
    startDate: string = faker.date.past().toISOString(),
    endDate: string = faker.date.future().toISOString(),
    type: CampaignTypes = CampaignTypes.LOYALTYCHALLENGE,
    campaignId: number = faker.number.int(1000)
  ) {
    this.end_date = endDate;
    this.type_campaign = type;
    this.start_date = startDate;
    this.campaign_id = campaignId;
  }
}

export const buildDate: (daysOffset: number) => Date = (daysOffset = 0) => {
  const date: Date = new Date();
  date.setDate(date.getDate() + daysOffset);
  return date;
};

export const getMonthDates: (monthOffset?: number) => {
  firstDay: Date;
  lastDay: Date;
} = (monthOffset: number = 0) => {
  const now: Date = new Date();
  const monthNumber: number = now.getMonth() + monthOffset;
  const year: number = now.getFullYear();
  return {
    firstDay: new Date(year, monthNumber, 1),
    lastDay: new Date(year, monthNumber + 1, 0),
  };
};

export const getWeekDates: (weekOffset?: number) => {
  firstDay: Date;
  lastDay: Date;
} = (weekOffset: number = 0) => {
  const now: Date = new Date();
  const day: number = now.getDay();
  // Monday-based week: shift Sunday (0) back to the previous Monday.
  const diffToMonday: number = (day === 0 ? -6 : 1) - day;
  const firstDay: Date = new Date(now);
  firstDay.setDate(now.getDate() + diffToMonday + weekOffset * 7);
  const lastDay: Date = new Date(firstDay);
  lastDay.setDate(firstDay.getDate() + 6);
  return { firstDay, lastDay };
};

export const generateCampaigns: (
  type: CampaignTypes
) => Record<string, MockCampaign[]> = (
  type: CampaignTypes
): Record<string, MockCampaign[]> => {
  if (type === CampaignTypes.EVENT) {
    return {
      current: [
        new MockCampaign(
          getMonthDates().firstDay.toISOString(),
          getMonthDates().lastDay.toISOString(),
          CampaignTypes.EVENT,
          2000
        ),
      ],
      completed: [
        new MockCampaign(
          getMonthDates(-2).firstDay.toISOString(),
          getMonthDates(-2).lastDay.toISOString()
        ),
        new MockCampaign(
          getMonthDates(-1).firstDay.toISOString(),
          getMonthDates(-1).lastDay.toISOString()
        ),
      ],
    };
  } else if (type === CampaignTypes.LOYALTYCHALLENGE_BIS) {
    return {
      current: [
        new MockCampaign(
          getMonthDates().firstDay.toISOString(),
          getMonthDates().lastDay.toISOString(),
          type,
          100
        ),
      ],
      completed: [
        new MockCampaign(
          getMonthDates(-2).firstDay.toISOString(),
          getMonthDates(-2).lastDay.toISOString(),
          type,
          101
        ),
        new MockCampaign(
          getMonthDates(-1).firstDay.toISOString(),
          getMonthDates(-1).lastDay.toISOString(),
          type,
          102
        ),
      ],
      future: [
        new MockCampaign(
          getMonthDates(2).firstDay.toISOString(),
          getMonthDates(2).lastDay.toISOString()
        ),
      ],
    };
  } else if (type === CampaignTypes.LOYALTYCHALLENGE) {
    return {
      current: [
        new MockCampaign(
          getMonthDates().firstDay.toISOString(),
          getMonthDates(1).lastDay.toISOString(),
          type,
          200
        ),
      ],
      future: [
        new MockCampaign(
          getMonthDates(2).firstDay.toISOString(),
          getMonthDates(2).lastDay.toISOString(),
          type,
          203
        ),
      ],
      completed: [
        new MockCampaign(
          getMonthDates(-2).firstDay.toISOString(),
          getMonthDates(-2).lastDay.toISOString(),
          type,
          201
        ),
        new MockCampaign(
          getMonthDates(-1).firstDay.toISOString(),
          getMonthDates(-1).lastDay.toISOString(),
          type,
          202
        ),
      ],
    };
  } else {
    return {
      current: [
        new MockCampaign(
          getWeekDates().firstDay.toISOString(),
          getWeekDates().lastDay.toISOString(),
          type,
          200
        ),
      ],
      completed: [
        new MockCampaign(
          getMonthDates().firstDay.toISOString(),
          buildDate(-2).toISOString(),
          type,
          201
        ),
        new MockCampaign(
          getMonthDates(-1).firstDay.toISOString(),
          getMonthDates(-1).lastDay.toISOString(),
          type,
          202
        ),
      ],
    };
  }
};
